import Icon from "@material-ui/icons/Label";

import Add from "./Add";
import Edit from "./Edit";
import List from "./List";

const Labels = { Icon, Add, Edit, List };

export default Labels;
